import React, { useMemo, useState } from "react";
import PbUmkuService from "../../../../services/pbumku/PbumkuService";
import { useNavigate } from "react-router-dom";
import { Col, Nav, Row, Spinner, Tab } from "react-bootstrap";
import Card from "../../../../components/Card";
import ViewCpibHeader from "./view/ViewCpibHeader";
import ViewCpibDetail from "./view/ViewCpibDetail";
import ViewCpibDok from "./view/ViewCpibDok";

const ViewEditCpibManual = () => {
    const [selectedTab, setSelectedTab] = useState('entitas')
    const [dataHeader, setDataHeader] = useState({})
    const [dataDetail, setDataDetail] = useState({})
    const [dataDokumen, setDataDokumen] = useState({})
    const [loading, setLoading] = useState(false)
    const [nomorAju, setNomorAju] = useState(null)

    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const navigate = useNavigate()

    const handleSelectTab = async (key) => {
        setLoading(true)
        let nomorAju = localStorage.getItem('nomorAjuPrimerStorage')
        setSelectedTab(key)
        let response
        try {
            if (key === 'entitas') {
                if (nomorAju !== null) {
                    response = await pbumkuService.getUmkuPembenihan(nomorAju)
                    setDataHeader(response.data)
                } else {
                    setDataHeader({})
                }
            } else if (key === 'detail') {
                if (nomorAju !== null) {
                    // response = await pbumkuService.listUmkuDok(nomorAju)
                    // setDataDetail(response.data)
                } else {
                    setDataDetail({})
                }
            } else if (key === 'dokumen') {
                if (nomorAju !== null) {
                    response = await pbumkuService.listUmkuDok(nomorAju)
                    setDataDokumen(response.data)
                } else {
                    setDataDokumen({})
                }
            }
        } catch (error) {
            setDataHeader({})
            setDataDokumen({})
        }
        setLoading(false)
    }

    const backToList = () => {
        navigate('/pbumku/cpib/daftar-manual')
    }

    useState(() => {
        let nomorAju = localStorage.getItem('nomorAjuPrimerStorage')
        const fetchAllOptions = async (noaju) => {
            setLoading(true)
            try {
                let response
                if (selectedTab === 'entitas') {
                    if (nomorAju !== null) {
                        response = await pbumkuService.getUmkuPembenihan(nomorAju)
                        setDataHeader(response.data)
                    } else {
                        setDataHeader({})
                    }
                } else if (selectedTab === 'detail') {
                    if (nomorAju !== null) {
                        setNomorAju(nomorAju)
                        response = await pbumkuService.listUmkuPembenihanDetail(nomorAju)
                        setDataDetail(response.data)
                    } else {
                        setDataDetail({})
                    }
                } else if (selectedTab === 'dokumen') {
                    if (nomorAju !== null) {
                        setNomorAju(nomorAju)
                        response = await pbumkuService.listUmkuDok(nomorAju)
                        setDataDokumen(response.data)
                    } else {
                        setDataDokumen({})
                    }
                }
            } catch (error) {
                setDataHeader({})
                setDataDetail({})
                setDataDokumen({})
            }
            setLoading(false)
        }
        fetchAllOptions(nomorAju)
        setNomorAju(nomorAju)
    }, [selectedTab])

    return (
        <div>
            <Row>
                <Col sm="12" lg="13">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Form Permohonan Sertifikasi CPIB</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <Tab.Container defaultActiveKey="entitas" onSelect={handleSelectTab} activeKey={selectedTab}>
                                <Nav variant='tabs'>
                                    <Nav.Item>
                                        <Nav.Link eventKey={'entitas'}>Entitas</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey={'detail'} disabled={nomorAju === null}>Komoditas</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link eventKey={'dokumen'} disabled={nomorAju === null}>Dokumen</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                                <Tab.Content>
                                    <Tab.Pane eventKey={'entitas'}>
                                        {loading && <Spinner animation='border' />}
                                        <ViewCpibHeader dataHeader={dataHeader} cancelHeader={backToList} saveHeader={handleSelectTab}/>
                                    </Tab.Pane>
                                </Tab.Content>
                                <Tab.Content>
                                    <Tab.Pane eventKey={'detail'}>
                                        {loading && <Spinner animation='border' />}
                                        <ViewCpibDetail dataDetail={dataDetail} saveDetail={backToList} cancelDetail={handleSelectTab}/>
                                    </Tab.Pane>
                                </Tab.Content>
                                <Tab.Content>
                                    <Tab.Pane eventKey={'dokumen'}>
                                        {loading && <Spinner animation='border' />}
                                        <ViewCpibDok dataDokumen={dataDokumen} saveDokumen={backToList} cancelDokumen={handleSelectTab}/>
                                    </Tab.Pane>
                                </Tab.Content>
                            </Tab.Container>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default ViewEditCpibManual